mutation RemoveEventMember($eventId: ID!, $userId: String!) {
  result: StreamToolsRemoveEventMember(eventId: $eventId, userId: $userId) {
    id
    deleted
  }
}
